import { CONFIG } from '../../core/config';
import { RunnableModelSearchResult as RunnableEquipmentFunctionModelSearchResult } from './equipment-function-model-search-result';
import { EquipmentFunctionModelSelectionCriteriaBase } from './equipment-function-model-selection-criteria-base';

export class RunnableEquipmentFunctionModelSelectionCriteria extends EquipmentFunctionModelSelectionCriteriaBase {
  readonly friendlyTypeNameSingular: string = 'Runnable Equipment Function Model Selection Criteria';
  readonly apiRoute: string = CONFIG.apiRoutes.runnableEquipmentFunctionModelSelection;

  searchResult: RunnableEquipmentFunctionModelSearchResult = new RunnableEquipmentFunctionModelSearchResult();

  json() {
    return this;
  }

  loadFromJson(data: any) {
    super.loadFromJson(data);

    this.searchResult = new RunnableEquipmentFunctionModelSearchResult();
    if (data.searchResult) {
      this.searchResult.loadFromJson(data.searchResult);
    }
  }

  hasModel(): boolean {
    return this.searchResult && this.searchResult.foundModel;
  }

  modelName(): string {
    return this.searchResult.foundModel ? this.searchResult.modelName : EquipmentFunctionModelSelectionCriteriaBase.unfoundModelName;
  }
}
